import businessIcon from "@assets/images/bussiness_icon.svg";
import {
  Box,
  Card,
  CardContent,
  Container,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
const useStyles = makeStyles(
  {
    bussinessIcon: {
      float: "left",
      margin: "-5px 10px 0 5px",
      width: "25px"
    },
    cardContent: {
      padding: "20px",
      width: "100%"
    },
    categories: {
      fontSize: "18px",
      margin: "0 0 20px",
      position: "relative",
      top: "15px"
    },
    fieldBox: {
      borderBottom: "1px solid #ccc",
      margin: "0 0 20px",
      padding: "15px 0 0",
      position: "relative"
    },
    fieldName: {
      color: "#0030FF",
      fontSize: "11px",
      fontWeight: 400,
      left: 0,
      position: "absolute",
      top: 0
    },
    formLabel: {
      color: "#0030FF",
      fontSize: "16px",
      left: "0",
      position: "absolute",
      top: "-30px"
    },
    mainCard: {
      alignItems: "center",
      display: "flex",
      marginTop: "40px",
      padding: "10px 20px 50px",
      paddingBottom: "50px",
      position: "relative",
      width: "800px"
    },
    root: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      margin: "0 auto",
      maxWidth: 800,
      padding: 0
    }
  },
  { name: "BusinessDetailsView" }
);

interface BusinessDetailsViewProp {
  brand: any;
}

export const BusinessDetailsView: React.FC<BusinessDetailsViewProp> = ({
  brand
}) => {
  // console.log(brand);
  const classes = useStyles({});
  return (
    <Container className={classes.root}>
      <Card className={classes.mainCard}>
        <Box className={classes.formLabel}>
          <img className={classes.bussinessIcon} src={businessIcon} /> Business
          Details
        </Box>
        <CardContent className={classes.cardContent}>
          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Business Information
          </Typography>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Lease Name:</strong>
            {brand.name}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Company Name:</strong>
            {brand.legalName}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Classification:</strong>
            {brand.storeType}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Tin No.:</strong>
            {brand.tinNo}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Complete Address:</strong>
            {brand.completeAddress}
          </div>

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Authorized Signatory
          </Typography>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Signatory Name:</strong>
            {brand.completeAddress}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>
              Signatory Designation:
            </strong>
            {brand.signatoryDesignation}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Signatory Email:</strong>
            {brand.signatoryEmail}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Signatory Mobile No.:</strong>
            {brand.signatoryMobileNo}
          </div>

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Bank Details
          </Typography>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Bank Account Name:</strong>
            {brand.bankAccountName}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Bank Account No.:</strong>
            {brand.bankAccountNo}
          </div>

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Finance Contact Details
          </Typography>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Finance Name:</strong>
            {brand.financeName}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Finance Email:</strong>
            {brand.financeEmail}
          </div>
          <div className={classes.fieldBox}>
            <strong className={classes.fieldName}>Finance Mobile No.:</strong>
            {brand.financeMobileNo}
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};
export default BusinessDetailsView;
